import { useCallback, useState } from 'react';

import { ServiceItem } from '../../../Services.types';
import { useHideServiceQuery } from '../queries';

const useHideServiceModal = () => {
  const [serviceData, setServiceData] = useState<ServiceItem | null>(null);
  const [isHiding, setIsHiding] = useState(true);
  const [isVisible, setIsVisible] = useState(false);

  const { handleHideService, handleUnhideService, isLoading } = useHideServiceQuery();

  const handleOpenHide = useCallback((service: ServiceItem) => {
    setServiceData(service);
    setIsHiding(true);
    setIsVisible(true);
  }, []);

  const handleOpenUnhide = useCallback((service: ServiceItem) => {
    setServiceData(service);
    setIsHiding(false);
    setIsVisible(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    setServiceData(null);
  }, []);

  const handleConfirm = useCallback(async () => {
    if (!serviceData) return;

    if (isHiding) {
      await handleHideService(serviceData.id, serviceData.name);
    } else {
      await handleUnhideService(serviceData.id, serviceData.name);
    }

    handleClose();
  }, [serviceData, isHiding, handleHideService, handleUnhideService, handleClose]);

  return {
    isVisible,
    isHiding,
    isLoading,
    serviceName: serviceData?.name || '',
    handleOpenHide,
    handleOpenUnhide,
    handleClose,
    handleConfirm,
  };
};

export default useHideServiceModal;
